import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Router, ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material";
import { RemoveSizeComponent } from '../remove-size/remove-size.component';
import { AddColorRowComponent } from '../add-color-row/add-color-row.component';
import { UploadColorImageComponent } from '../upload-color-image/upload-color-image.component';
import { ProductService } from "../../_services/product.service";
import { AddBrandComponent } from '../add-brand/add-brand.component';
import { AddCategoryComponent } from '../add-category/add-category.component';
import { AddStyleComponent } from '../add-style/add-style.component';
import { AddFitsComponent } from '../add-fits/add-fits.component';
import { CreateSizeComponent } from '../create-size/create-size.component';
import { UserService } from "../../_services/user.service";


import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";
import { element } from 'protractor';

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.css']
})
export class AddProductComponent implements OnInit {
  public loading = false;
  addProductForm: FormGroup;
  public viewProductData: any = {};
  productId: string;
  public filters: any = {

  };
  public colorFormArray: FormArray;
  selectedFile = [];
  imageUrl = [];
  public optionsLists: Array<any> = [];
  public optionsListsArray: Array<any> = [];
  productStyleSelectedFile = null;
  productStyleImage = null
  public locationList = [{ value: 'front', name: 'Front' },
  { value: 'back', name: 'Back' },
  { value: 'side', name: 'Side' }
  ]
  public imageLocation = "";
  public activeClass: string;

  options = {};
  public sizeList = [];
  selectedSize = [];
  //   public optionData = [{
  //     "0": {
  //       "3f97dac8d0b404b9fff5622c62e1ccf2": {
  //         "price": 0,
  //         "weight": 0,
  //         "quantity": 0
  //       },
  //       "8bf0eb0574ec3fe64ddcec2eb945334e": {
  //         "price": 0,
  //         "weight": 0,
  //         "quantity": 0
  //       },
  //       "3d737ea3680a1cb3dc07f5f715e4f0b5": {
  //         "price": 0,
  //         "weight": 0,
  //         "quantity": 0
  //       },
  //       "23e20ff93614684ff5c4a72b9508cfb9": {
  //         "price": 0,
  //         "weight": 0,
  //         "quantity": 0
  //       },
  //       "4a899c207d5f332ece18182a9d41cdff": {
  //         "price": 0,
  //         "weight": 0,
  //         "quantity": 0
  //       },
  //       "4c4db9b6d297f07e7af15f4818bff279": {
  //         "price": 0,
  //         "weight": 0,
  //         "quantity": 0
  //       },
  //       "a3fbdbe6956803b51a2b166806e3966c": {
  //         "price": 0,
  //         "weight": 0,
  //         "quantity": 0
  //       }
  //     },
  //     color_id: '',
  //     colorImage: ''
  //   }  

  // ];
  public optionData = [];
  checksize = [];
  isDesible = false;
  constructor(private formBuilder: FormBuilder,
    private commonService: CommonService,
    private ProductService: ProductService,
    private UserService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private _flashMessagesService: FlashMessagesService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.addProductForm = this.formBuilder.group({
      brand: [null, Validators.required],
      category: [null, Validators.required],
      name: [null, Validators.required],
      style: [null, Validators.required],
      fits: [null, Validators.required],
      description: [null, Validators.required],
      title: [null, Validators.required]
    });
    this.getfilterList();

  }

  onProductFileChanged(event, index, colorId) {
    if (colorId != '' && this.imageLocation != '') {
      if (this.selectedFile[colorId]) {
        Object.assign(this.selectedFile[colorId], {
          [this.imageLocation]: {
            imgLocation: this.imageLocation,
            selectedFile: event.target.files[0]

          }
        });
      }
      else {
        this.selectedFile[colorId] = {
          [this.imageLocation]: {
            imgLocation: this.imageLocation,
            selectedFile: event.target.files[0]
          }
        }
      }

      var render = new FileReader();
      render.onload = (event: any) => {
        // if (this.data.group_id) {
        //   this.imageUrl[index] = event.target.result;
        // }
        // else {
        //   this.imageUrl.push(event.target.result);
        // }

        //alert(event.target.result);     
      }
      render.readAsDataURL(event.target.files[0]);
    }
    else {
      this._flashMessagesService.show("Please select product color and image location", {
        cssClass: "alert-danger",
        timeout: 2000
      });
    }
  }

  onStyleFileChanged(event) {
    this.productStyleSelectedFile = event.target.files[0];
    var render = new FileReader();
    render.onload = (event: any) => {
      this.productStyleImage = event.target.result;

    }
    render.readAsDataURL(this.productStyleSelectedFile);
  }

  getfilterList = function () {
    this.loading = true;
    this.options = {
      id: localStorage.getItem("userID")
    }
    this.commonService.apiService(
      "POST",
      "custom/filters",
      this.options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.filters = response.data;
            this.sizeList = response.data.own_garments_sizes;
            if (this.route.snapshot.params["productId"]) {
              this.activeClass = 'active';
              this.productId = this.route.snapshot.params["productId"];
              this.viewProductDetail(this.route.snapshot.params["productId"]);
            } else {
              this.loading = false;
            }
          } else {
            this.loading = false;
          }
        } else {
          this.loading = false;
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }
  trackByFn(index: any, item: any) {
    return index;
  }

  isFieldValid(field: string) {
    return (
      !this.addProductForm.get(field).valid &&
      this.addProductForm.get(field).touched
    );
  }

  saveProduct = function (postData) {
    this.loading = true;
    let apiName = 'product/create';
    const formData = new FormData();
    formData.append('brand_id', postData.brand);
    formData.append('title', postData.title);
    formData.append('description', postData.description);
    formData.append('shop_id', localStorage.getItem("userID"));
    if (this.productId) {
      formData.append('id', this.productId);
      apiName = "product/edit"
    }
    formData.append('name', postData.name);
    var catCount = 0;
    postData.category.forEach((element, index) => {
      catCount += index;
      formData.append('categories[' + catCount + ']', element);
    });
    postData.style.forEach((element, index) => {
      catCount += 1;
      formData.append('categories[' + catCount + ']', element);
    });
    postData.fits.forEach((element, index) => {
      catCount += 1;
      formData.append('categories[' + catCount + ']', element);
    });
    this.selectedSize.forEach((element, index) => {
      formData.append('sizes[' + index + ']', element.size_id);
    });

    if (this.productStyleSelectedFile != null) {
      formData.append('style_image', this.productStyleSelectedFile, this.productStyleSelectedFile.name);
    }
    else {
      if (apiName == 'product/create') {
        this.loading = false;
        this._flashMessagesService.show("Please upload product style image", {
          cssClass: "alert-danger",
          timeout: 5000
        });
        window.scrollTo(0, 0);
        return;
      } else {
        formData.append('style_image', '');
      }

    }

    for (let index = 0; index < this.optionData.length; index++) {
      if (this.optionData[index].color.primary_color_id == '') {
        this.loading = false;
        this._flashMessagesService.show("Please Select product color", {
          cssClass: "alert-danger",
          timeout: 5000
        });
        window.scrollTo(0, 0);
        return;
      }
      let color_id = this.optionData[index].color.primary_color_id;
      let isduplicateColor = this.optionData.filter(x => x.color.primary_color_id == this.optionData[index].color.primary_color_id).length;
      if (isduplicateColor > 1) {
        this.loading = false;
        this._flashMessagesService.show("Duplicate color is not allowed", {
          cssClass: "alert-danger",
          timeout: 5000
        });
        window.scrollTo(0, 0);
        return;
      }
      for (let idx = 0; idx < this.optionData[index].sizes.length; idx++) {

        let sizeId = this.optionData[index].sizes[idx].size_id;
        if (this.optionData[index].price[idx] == '' || this.optionData[index].price[idx] == 0) {
          this.optionData[index].price[idx] = 0;
        }
        if (this.optionData[index].quantity[idx] === '') {
          this.optionData[index].quantity[idx] = 0;
        }
        if (this.optionData[index].weight[idx] === '') {
          this.optionData[index].weight[idx] = 0;
        }
        formData.append('options[' + color_id + '][' + sizeId + '][price]', this.optionData[index].price[idx]);
        formData.append('options[' + color_id + '][' + sizeId + '][quantity]', this.optionData[index].quantity[idx]);
        formData.append('options[' + color_id + '][' + sizeId + '][weight]', this.optionData[index].weight[idx]);

        // });
      }
      formData.append('colors[' + index + ']', color_id);
      this.locationList.forEach((location, lindex) => {
        if (this.selectedFile[color_id] && this.selectedFile[color_id][location.value] && this.selectedFile[color_id][location.value].selectedFile) {
          formData.append('colors_images[' + color_id + '][' + location.value + ']', this.selectedFile[color_id][location.value].selectedFile, this.selectedFile[color_id][location.value].selectedFile.name);
        }
        // else{
        //   formData.append('color_images[' + color_id + '][' + location.value + ']','');
        // }
      })

    }

    //});

    this.commonService.apiService(
      "POST",
      apiName,
      formData
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          this.addProductForm.reset()
          this.backToList();

          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 5000
          });
        }
        window.scrollTo(0, 0);
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  }

  addOptionRow(colorData, sizeData) {
    let defaultData = {
      color: colorData,
      colorImage: '',
      price: new Array(sizeData.length).fill(0),
      weight: new Array(sizeData.length).fill(0),
      quantity: new Array(sizeData.length).fill(''),
      sizes: [...sizeData]
    }
    this.optionData.push(defaultData);

  }

  deleteOptionRow(index, colorId) {
    if (this.optionData.length > 1) {
      if (this.productId) {
        if (this.viewProductData.is_ordered == true) {
          let isColorExist=this.viewProductData.colors.findIndex(x=>x.color_id==colorId);
          if(isColorExist==-1)
          {
            this.optionData.splice(index, 1);
            this.selectedFile.splice(index, 1);
            this.locationList.forEach((location, lindex) => {
              if (this.imageUrl[colorId] && this.imageUrl[colorId][location.value] && this.imageUrl[colorId][location.value].imageUrl) {
                this.deleteColorImage(this.productId, colorId, location);
              }
            })
          }
          else{
            this._flashMessagesService.show('Product color row can not remove.Product exist in order', {
              cssClass: "alert-danger",
              timeout: 5000
            });
            window.scroll(0,0);
          }      
          
        }
        else {
          this.optionData.splice(index, 1);
          this.selectedFile.splice(index, 1);
          this.locationList.forEach((location, lindex) => {
            if (this.imageUrl[colorId] && this.imageUrl[colorId][location.value] && this.imageUrl[colorId][location.value].imageUrl) {
              this.deleteColorImage(this.productId, colorId, location);
            }
          })

        }
      }
      else {
        this.optionData.splice(index, 1);
        this.selectedFile.splice(index, 1);
      }
    }
  }

  deleteColorImage = function (id, colorId, location) {
    this.commonService.apiService(
      "DELETE",
      'product/colorimage/' + id + "/" + localStorage.getItem("userID") + "/" + colorId + "/" + location

    ).subscribe(
      (response: any) => {
        if (response.status === true) {

        }
      },
      err => {
        console.log("Error", err.error.message);
      }
    );
  }

  backToList() {
    this.router.navigate(['/products/custom-listing']);

  }
  openAddColorSizeDialog(i): void {
    const dialogRef = this.dialog.open(RemoveSizeComponent, {
      width: "250px",
      data: {
        sizeList: this.selectedSize
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        result.sizeId.forEach(element => {
          this.addColorSize(i, element);
        });
      }
    });
  }

  onSizeChange(event) {
    if (event.isUserInput) {
      if (this.optionData.length > 0) {
        if (event.source.selected) {
          this.optionData.forEach((element, i) => {
            this.addColorSize(i, event.source.value);
          })
        }
        else {
          this.optionData.forEach((element, i) => {
            this.deleteColorSize(i, event.source.value.size_id, 'All');
          })
          this._flashMessagesService.show("size remove successfully", {
            cssClass: "alert-success",
            timeout: 2000
          });

        }
      }
    }
  }

  addColorSize(i, size) {
    let sizeIndex = this.optionData[i].sizes.findIndex(x => x.size_id == size.size_id);
    if (sizeIndex == -1) {
      this.optionData[i].sizes.push(size);
      this.optionData[i].price.push(0);
      this.optionData[i].quantity.push('');
      this.optionData[i].weight.push(0);
    }
  }

  deleteColorSize(i, sizeId, type) {
    // if (this.productId) {
    //   if (this.viewProductData.is_ordered == true) {
    //     this._flashMessagesService.show('Product size can not remove.Product exist in order', {
    //       cssClass: "alert-danger",
    //       timeout: 5000
    //     });
    //     return
    //   }
    // }
    if (this.productId) {
      if (this.viewProductData.is_ordered == true) {
        let isExist = this.viewProductData.sizes.findIndex(x => x.size_id == sizeId);
        if (isExist != -1) {
          this._flashMessagesService.show('Product size can not remove.Product exist in order', {
            cssClass: "alert-danger",
            timeout: 5000
          });
          return
        }
      }
    }

    let sizeIndex = this.optionData[i].sizes.findIndex(x => x.size_id == sizeId);
    if (sizeIndex != -1) {
      this.optionData[i].sizes.splice(sizeIndex, 1);
      this.optionData[i].price.splice(sizeIndex, 1);
      this.optionData[i].quantity.splice(sizeIndex, 1);
      this.optionData[i].weight.splice(sizeIndex, 1);
      if (type == 'One') {
        this._flashMessagesService.show("size remove successfully", {
          cssClass: "alert-success",
          timeout: 2000
        });
      }


    }
  }
  compareObjects(o1: any, o2: any) {
    if (o1.size_id == o2.size_id) {

      return true;
    }
    else return false
  }
  openColorDialog(colorIdx) {
    console.log('color ids',colorIdx);
    //let sizeData =this.addProductForm.get('sizeId').value == 'All' ? this.sizeList : this.addProductForm.get('sizeId').value;
    if (this.selectedSize.length != 0) {
      const dialogRef = this.dialog.open(AddColorRowComponent, {
        width: "250px",
        data: {
          sizeList: this.sizeList,
          colorList: this.filters.colors,
          colorIdx: colorIdx
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.colorData && this.selectedSize) {
          if (colorIdx === '') {
            result.colorData.forEach(element => {
              this.addOptionRow(element, this.selectedSize);
            });
          }
          else {
            this.updateColor(colorIdx, result.colorData);
          }
        }
      });
    }
    else {
      this._flashMessagesService.show('Please select sizes from size list', {
        cssClass: "alert-danger",
        timeout: 5000
      });

    }

  }
  updateColor(colorIndex, colorData) {
    this.optionData[colorIndex].color = colorData[0];
  }

  openUploadImageDialog(colorId) {
    const dialogRef = this.dialog.open(UploadColorImageComponent, {
      width: "250px",
      data: {
        colorId: colorId,
        selectedFile: this.selectedFile,
        imageUrl: this.imageUrl
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });

  }

  viewProductDetail(productId) {
    let productOptions = {
      product_id: productId,
      provider: 'custom',
      is_admin:true
    };
    
    // if (productId) {
    //   productOptions.product_id = productId;
    // }
    this.ProductService.getProductById(productOptions).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this.viewProductData = response.data;
          //Convert Object to Array
          const mapped = Object.keys(this.viewProductData.options).map(key => ({ colorid: key, sizeid: this.viewProductData.options[key] }));
          for (var x in mapped) {
            //Convert Inner Object to Array
            const dd = Object.keys(mapped[x]['sizeid']).map(key => ({ size: key, value: mapped[x]['sizeid'][key] }));
            mapped[x]['sizeid'] = dd;
          }
          this.optionsListsArray = mapped;
          this.setFormData(response.data);
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  setFormData(productData) {
    this.setColorRowData();
    this.productStyleImage = productData.style_image;
    let categoryIds = [];
    productData.categories.forEach(element => {
      categoryIds.push(element.categoryId);
    });
    let styleIds = [];
    productData.styles.forEach(element => {
      styleIds.push(element.styleId);
    });
    let fitIds = [];
    productData.fits.forEach(element => {
      fitIds.push(element.fitId);
    });

    this.selectedSize = productData.sizes;
    this.addProductForm.patchValue({
      'brand': productData.brand_id,
      'name': productData.name,
      'title': productData.title,
      'description': productData.description,
      'category': categoryIds,
      'fits': fitIds,
      'style': styleIds
      //'sizeId': productData.sizes
    });
  }

  setColorRowData() {
    var colorData = {};
    if (this.viewProductData && this.viewProductData.colors && this.viewProductData.colors.length > 0) {
      this.optionsListsArray.forEach((element, index) => {
        let colors = this.viewProductData.colors.find(x => x.color_id == element.colorid);
        if (colors && typeof colors.color_image !== 'undefined') {
          colorData = {
            'image': colors.color_image,
            'name': colors.name,
            'primary_color_id': colors.color_id
          };
          this.imageUrl[colors.color_id] = {
            ['front']: {
              imageUrl: colors.front_image
            }
          }
          if (this.imageUrl[colors.color_id]) {
            if (colors.back_image) {
              Object.assign(this.imageUrl[colors.color_id], {
                ['back']: {
                  imageUrl: colors.back_image
                }
              });
            }
            if (colors.side_image) {
              Object.assign(this.imageUrl[colors.color_id], {
                ['side']: {
                  imageUrl: colors.side_image
                }
              });
            }

          }

          var defaultData = {
            color: colorData,
            colorImage: '',
            price: new Array(),
            weight: new Array(),
            quantity: new Array(),
            sizes: new Array()
          };
          element.sizeid.forEach(element => {
            defaultData.price.push(element.value.price);
            defaultData.quantity.push(element.value.quantity);
            defaultData.weight.push(element.value.weight);
            defaultData.sizes.push(this.sizeList.find(x => x.size_id == element.size));
          });
          this.optionData.push(defaultData);
        }
      });
    }
  }

  copyColorRow(copyData) {
    let data = JSON.parse(JSON.stringify(copyData));
    this.optionData.push(data);

  }

  openBrandDialog(): void {
    const dialogRef = this.dialog.open(AddBrandComponent, {
      width: "250px",
      data: {
        //name:'test'

      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getBrandList();
      }
    });
  }

  openCategoryDialog(): void {
    const dialogRef = this.dialog.open(AddCategoryComponent, {
      width: "250px",
      data: {
        //name:'test'

      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getCategoryList();
      }
    });
  }

  openStyleDialog(): void {
    const dialogRef = this.dialog.open(AddStyleComponent, {
      width: "250px",
      data: {
        //name:'test'

      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getStyleList();
      }
    });
  }

  openFitDialog(): void {
    const dialogRef = this.dialog.open(AddFitsComponent, {
      width: "250px",
      data: {
        //name:'test'

      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getFitList();
      }
    });
  }
  openSizeDialog(): void {
    const dialogRef = this.dialog.open(CreateSizeComponent, {
      width: "250px",
      data: {
        //name:'test'

      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getSizeList();
      }
    });
  }

  getBrandList = function () {
    this.options = {
      id: localStorage.getItem("userID")
    }
    this.commonService.apiService(
      "POST",
      "custom/brand",
      this.options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.filters.brands = response.data.brands;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }


  getStyleList = function () {
    this.options = {
      id: localStorage.getItem("userID")
    }
    this.commonService.apiService(
      "POST",
      "custom/style",
      this.options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.filters.styles = response.data.styles;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  getCategoryList = function () {
    this.options = {
      id: localStorage.getItem("userID")
    }
    this.commonService.apiService(
      "POST",
      "custom/category",
      this.options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.filters.categories = response.data.categories;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  getFitList = function () {
    this.options = {
      id: localStorage.getItem("userID")
    }
    this.commonService.apiService(
      "POST",
      "custom/fit",
      this.options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.filters.fits = response.data.fits;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  getSizeList = function () {
    this.options = {
      id: localStorage.getItem("userID")
    }
    this.commonService.apiService(
      "POST",
      "custom/size",
      this.options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.sizeList = response.data.own_garments_sizes;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  disableSizeOption(sizeId) {
    if (this.productId) {
      if (this.viewProductData.is_ordered == true) {
        let isExist = this.viewProductData.sizes.findIndex(x => x.size_id == sizeId);
        if (isExist != -1) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/add-product/add-product.component.ts